import { graphqlApiWithPersisted } from './graphqlApi';

interface MeReferralCodeResponse {
  data: { meReferralCode: string };
}

export const referralApi = graphqlApiWithPersisted.injectEndpoints({
  endpoints: (builder) => ({
    meReferralCode: builder.query<string, void>({
      query: () => ({
        url: '/graphql/webapp?meReferralCode',
        method: 'POST',
        body: {
          query: `query MeReferralCode {
            meReferralCode
          }`,
        },
      }),
      transformResponse: (response: MeReferralCodeResponse) => response.data.meReferralCode,
    }),
  }),
});

export const { useMeReferralCodeQuery } = referralApi;
